import { defaults } from 'lodash'

export const initialInventoryState = {
  assets: {},
  defects: {},
  selectedAssets: [],
  groupToAssetsMap: null,
  images: [],
}

export default defaults({}, initialInventoryState)
